import { Component } from '@angular/core';
import { RegisterModel } from '../shared/interfaces/registerModel';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginService } from '../shared/services/login.service';
import { Router } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { ErrorComponent } from '../shared/error/error.component';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [FormsModule,CommonModule,TranslateDirective, ErrorComponent],
  templateUrl: './register.component.html',
  styleUrl: './register.component.less'
})
export class RegisterComponent {
  registerModel:RegisterModel={
    Email: "",
    Name: "",
    Surname: "",
    Street: "",
    StreetNumber: "",
    Password: "",
    ConfirmPassword: "",
    PhoneNumber: ""
  }

  errors: any;
  successfulReg: boolean | null = null;
  //successfulReg=false;
  constructor(private service: LoginService, private router: Router){}

  ngOnInit(){}

  register(){
    this.successfulReg = null;
    this.errors = null;
    this.registerModel.StreetNumber=this.registerModel.StreetNumber.toString();
    this.service.register(this.registerModel).subscribe({
      next: res =>{
        if(res) {
          this.successfulReg=true;
          this.errors = null;
        }
      },
      error: err=>{      
        this.successfulReg = false;
        this.errors=err?.error?.errors || err?.error || err;
      }
    })

  }
  redirect(){
    this.router.navigate(['/login']);
  }

}

